import withFullScreen from "../full-view/withFullScreen";
import S3Image from "./S3Image";

export const S3ImageFullScreen = withFullScreen(S3Image);
